import { render, staticRenderFns } from "./TicketCreateForm.vue?vue&type=template&id=a16e1712&"
import script from "./TicketCreateForm.vue?vue&type=script&lang=ts&"
export * from "./TicketCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports